import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { provideRouter } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import {
  AUTH_PROVIDERS,
  accessTokenAuthInterceptor,
  globalHttpErrorInterceptor,
  provideRemoteUpdateDomain
} from '@ottobock/remote-update/domain';
import { ENV_CONFIG } from '@ottobock/shared/domain';

import { environment } from '../environments/environment';

import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    // Angular 22 made fetch the default HttpClient backend; withXhr() pins the pre-22 XHR
    // behavior so this upgrade doesn't also change HTTP transport.
    provideHttpClient(
      withXhr(),
      withInterceptors([accessTokenAuthInterceptor, globalHttpErrorInterceptor])
    ),
    provideStore(),
    provideEffects(),
    provideStoreDevtools({ maxAge: 25, logOnly: false }),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRemoteUpdateDomain({
      baseUrl: environment.apiUrl
    }),
    provideRouter(appRoutes),
    {
      provide: ENV_CONFIG,
      useValue: environment
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 4500,
        horizontalPosition: 'start',
        verticalPosition: 'bottom'
      }
    },
    ...AUTH_PROVIDERS
  ]
};
